import {Atom} from '@packages/systems/wfdl';

import {TText} from '@packages/systems/wfdl-ast';

// String atom does not currently render anything.
const StringRender = Atom.createRender(() => null);

export const StringAtom = Atom.create({
  showEmpty: false,
  render: StringRender,
  dataType: TText,
});
